<div class="container-fluid">
  <div class="d-flex justify-content-center">
    <div class="modal-content1">
      <div class="modal-body modal-wrapper px-3 px-sm-4" [ngStyle]="{ height: flexHeight }">
        <div class="row">
          <div class="col-12 file-div-wrap" [ngClass]="{ 'border-red-dropzone': !file && submit }">
            <button class="file-upload-button">
              <ng-container *ngIf="firstContainer">
                <app-svg classSvg="file-icon" iconType="document"></app-svg>
                <input title="" type="file" class="mx-auto" id="fileSelect" (change)="upload($event)"/>
                <label for="" class="file-lable1 mt-3">{{ importCompanyVM.lable1 }} </label>
                <label class="file-lable2">{{ importCompanyVM.lable2 }}</label>
              </ng-container>
              <div *ngIf="uploadSuccess" class="d-flex justify-content-end w-100 ">
                <app-svg iconType="CircleClose" (click)="newImport()"></app-svg>
              </div>
              <ng-container *ngIf="uploadSuccess" class="success">
                <div class="row">
                  <div class="col-12 success-icon">
                    <img src="./assets/SVGIcons/uploadesuccess.svg" alt="" />
                  </div>
                </div>
                <label class="sucess mt-1 mt-sm-3 mb-1 mb-sm-2 text-gray">{{ importCompanyVM.lable4 }}</label>
                <div class="col-12" *ngFor="let item of file">
                  <span class="text-light-gray">{{ item.name }}</span>
                </div>
              </ng-container>
              <ng-container *ngIf="hideErrordiv">
                <div class="row">
                  <div class="col-12 error-icon">
                    <img src="./assets/SVGIcons/Erroricon.svg" alt="" />
                  </div>
                  <div class="col-12 mt-3">
                    <p class="text-gray">Error! Please try uploading your files again.</p>
                    <p class="text-decoration-underline mt-3"
                      [ngClass]=" hideErrordiv === true  ? 'text-primary-color'  : 'text-gray' "
                      (click)="showuploadedfile()">
                      Upload file
                    </p>
                  </div>
                </div>
              </ng-container>
            </button>
          </div>
          <div class="col-12  ps-0 d-flex  p-r-0 m-t-5 
            {{ errorMessageSupported ? 'mb-0' : 'mb-3' }}
            {{ errorMessageSupported ? 'justify-content-between' : 'justify-content-end' }}">
            <div class="d-flex flex-column">
              <div *ngIf="errorMessageSupported" class="text-red font-12">{{headerText}}</div>
            </div>
            <div class="download-svg">
              <a class="d-flex align-items-center"
                [href]="getSampleFilePath()"
                [download]="fileName"
                [ngClass]="hideErrordiv === true ? 'pe-none' : ''">
                <app-svg [ngClass]=" hideErrordiv === true ? 'svgicon' : 'download-svg-icon' "
                iconType="DownloadGreycolor">                        
                </app-svg>
                <span class="ps-1 download-btn" [ngClass]="!hideErrordiv === true ? 'text-semi-primary' : 'text-light-gray'">Download Sample File</span>
              </a>
            </div>
          </div>
          <div class="col-12 px-0 m-b-20">
            <p class="info-text">The system will automatically map matching fields from your spreadsheet.</p> 
            <p class="info-text">Unmapped fields can be assigned manually in the next step.</p> 
          </div>
          <div class="col-12 ps-0 m-b-10" *ngIf="currentTab !== tabName.CODECROSSWALK_TAB">
            <h6 class="text-gray">Assign</h6>
            <span *ngIf="routeUrl == routePath.IMPORTVENDOR_ROUTEPATH"
              class="text-light-gray font-10">
              Salesperson is required for “Mark as Company” vendors.</span>
          </div>
          <div class="col-12 assign-box">
            <div class="row row-gap-4" *ngIf="currentTab !== tabName.CODECROSSWALK_TAB">
              <div class="col-12 col-sm-6 ps-0" *ngIf="currentTab !== tabName.IMPORT_BOM_TAB">
                <app-dropdown [selectLabel]="'Salesperson'" [data]="salesPersonList" [required]="true"
                  [ngClass]="{'border-red': !insertUpdateImportDocumnets.importCompanyModel.salesPersonId && submit }"
                  [optionDisable]="insertUpdateImportDocumnets.importCompanyModel.altSalesPersonId "
                  [selectValue]="insertUpdateImportDocumnets.importCompanyModel.salesPersonId "
                  [positionStrategy]="'absolute'"
                  (selectValueEmit)="insertUpdateImportDocumnets.importCompanyModel.salesPersonId = $event">
                </app-dropdown>
              </div>
              <div class="col-12 col-sm-6 ps-0"  *ngIf="currentTab === tabName.IMPORT_BOM_TAB">
                <app-dropdown [selectLabel]="'Salesperson'" [data]="salesPersonList" [required]="true"
                  [ngClass]="{'border-red': !insertUpdateImportDocumnets.importModel.salesPersonId && submit }"
                  [optionDisable]="insertUpdateImportDocumnets.importModel.altSalesPersonId "
                  [selectValue]="insertUpdateImportDocumnets.importModel.salesPersonId "
                  [positionStrategy]="'absolute'"
                  (selectValueEmit)="insertUpdateImportDocumnets.importModel.salesPersonId = $event">
                </app-dropdown>
              </div>
              <div class="col-12 col-sm-6 ps-0 ps-sm-2 pe-sm-1" *ngIf="currentTab !== tabName.IMPORT_BOM_TAB">
                <app-dropdown [selectLabel]="'Buyer’s Rep'" 
                  [data]="buyerRepList"
                  [required]="routeUrl == routePath.IMPORTVENDOR_ROUTEPATH?true:false"
                  [ngClass]="{'border-red': !insertUpdateImportDocumnets.importCompanyModel.buyersId && submit && routeUrl == routePath.IMPORTVENDOR_ROUTEPATH }"
                  (selectValueEmit)="insertUpdateImportDocumnets.importCompanyModel.buyersId = $event "
                  [selectValue]="insertUpdateImportDocumnets.importCompanyModel.buyersId"
                  [positionStrategy]="'absolute'"
                ></app-dropdown>
              </div>
              <div class="col-12 col-sm-6 ps-0 ps-sm-2 pe-sm-1" *ngIf="currentTab == tabName.IMPORT_BOM_TAB">
                <app-dropdown [selectLabel]="'Company'" [data]="companyNameList"
                  [ngClass]="{'border-red': !insertUpdateImportDocumnets.importModel.companyId && submit }"
                  [required]="true"
                  [positionStrategy]="'absolute'"
                  (selectValueEmit)="insertUpdateImportDocumnets.importModel.companyId = $event;selectValueChange($event)"
                  [selectValue]="insertUpdateImportDocumnets.importModel.companyId"
                ></app-dropdown>
              </div>
            </div>
            <div class="row m-t-25" *ngIf="currentTab !== tabName.CODECROSSWALK_TAB">
              <div class="col-12 col-sm-6 ps-0" *ngIf="currentTab !== tabName.IMPORT_BOM_TAB">
                <app-dropdown [selectLabel]="'Alt Salesperson'" [data]="altSalePersonList"
                  [optionDisable]="insertUpdateImportDocumnets.importCompanyModel.salesPersonId"
                  (selectValueEmit)="insertUpdateImportDocumnets.importCompanyModel.altSalesPersonId = $event"
                  [selectValue]="insertUpdateImportDocumnets.importCompanyModel.altSalesPersonId"
                  [positionStrategy]="'absolute'"
                ></app-dropdown>
              </div>
              <ng-container *ngIf="currentTab == tabName.IMPORT_BOM_TAB">
                <div class="col-6 ps-0"></div>
                 <div class="col-12 col-sm-6 ps-0 ps-sm-2 pe-sm-1">
                  <app-dropdown [selectLabel]="'Contact'" [data]="contactNameList"
                    [disabled]="disabledContact" class="contactDropdown"
                    [positionStrategy]="'absolute'"
                    (selectValueEmit)="insertUpdateImportDocumnets.importModel.contactId = $event"
                    [selectValue]="insertUpdateImportDocumnets.importModel.contactId"
                  ></app-dropdown>
                </div>
              </ng-container>
            </div>
            <div class="row m-t-20">
              <div class="col-12 mt-2 ps-0">
                <h6 class="text-gray">Mapping Template</h6>
              </div>
              <div class="col-12 col-sm-6 m-t-10 ps-0">
                <div>
                  <app-custom-select  [options]="mappingTemplateList"
                    (select)="selectmappingTemplateId($event); showDescription() ; base64OfFile ? checkingValidateFiles():''"
                    (inputValueEmit)="updateList()"
                    [importCodecrosswalk]="currentTab === tabName.CODECROSSWALK_TAB"
                    ></app-custom-select>
                </div>
                <div class="mt-1 text-truncate">
                  <span class="font-10 text-light-gray mt-1 p-0 m-0  d-inline text-truncate"
                    ngbTooltip="{{ insertUpdateImportDocumnets?.templateData ?.templateDescription }}" placement="bottom">
                    ({{ insertUpdateImportDocumnets?.templateData ?.templateDescription == "" || insertUpdateImportDocumnets?.templateData ?.templateDescription == null
                    ? "Template Description shows here"
                    : insertUpdateImportDocumnets?.templateData ?.templateDescription }})
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer border-0 pt-3 pt-sm-0 pb-10">
    <div class="justify-content-end">
      <app-button *ngIf="currentTab !== tabName.CODECROSSWALK_TAB"
        [button_2]="true" [buttonClass]="'button button-info'" [buttonLable]="enumButtonName.CANCEL"
        (click)="closeTab()">
      </app-button>
      <app-button *ngIf="currentTab === tabName.CODECROSSWALK_TAB"
        [button_2]="true" [buttonClass]="'button button-info'" [buttonLable]="enumButtonName.CANCEL"
        (click)="close()">
      </app-button>
      <app-button *ngIf="currentTab !== tabName.CODECROSSWALK_TAB"
        class="popup-button button" (click)="navigateToMapTab()" [button_2]="true" 
        [buttonClass]="(uploadSuccess && !headerValue && !emptyFile && fileNotMatchError && !errorMessageSupported && 
        ((currentTab === tabName.IMPORT_BOM_TAB && insertUpdateImportDocumnets.importModel.salesPersonId && 
        insertUpdateImportDocumnets.importModel.companyId) || (currentTab !== tabName.IMPORT_BOM_TAB && 
        insertUpdateImportDocumnets.importCompanyModel.salesPersonId)))?'button button-primary':'button dark-info'"
        [buttonLable]="enumButtonName.NEXT" [inputReadonly]="buttonDisabled">
      </app-button>
      <app-button *ngIf="currentTab == tabName.CODECROSSWALK_TAB"
        class="popup-button button" (click)="navigateToMapTab()" [button_2]="true" 
        [buttonClass]="( uploadSuccess && !headerValue && !emptyFile && fileNotMatchError && !errorMessageSupported)?'button button-primary':'button dark-info'"
        [buttonLable]="enumButtonName.NEXT" [inputReadonly]="buttonDisabled">
      </app-button>
    </div>
  </div>
</div>